<template>
  <table style="border-collapse: collapse; width: 100%">
    <thead
      v-if="reports.length"
      class="header"
      :style="{
        'top': topPositionForHeader
      }"
    >
      <tr>
        <td
          class="header__item"
          v-for="(header, headerKey) in headers"
          :key="headerKey"
          :style="colStyles(header)"
          :class="{
            'active': header.key === orderBy.key
          }"
          @click="value.length > 1 ? onOrderBy(header.key) : false"
        >
          <template v-if="header.key === 'actions'">
            <v-checkbox
              v-model="checked"
              dense
              hide-details
              class="ma-0 pa-0"
              @change="toggleGroupReports"
            ></v-checkbox>
          </template>
          <template v-else-if="header.key === 'Invoice_Dur'">
            <div class="d-flex align-center">
              <span>{{ header.title }}</span>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    class="ml-1"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="setAllInvoiceDurToZero"
                  >
                    mdi-update
                  </v-icon>
                </template>
                <span>Set all Invoice Dur to 00:00 in this group</span>
              </v-tooltip>
              <v-icon x-small class="ml-auto">{{ orderWay(header.key) }}</v-icon>
            </div>
          </template>
          <template v-else>
            {{ header.title }}
            <v-icon x-small class="ml-auto">{{ orderWay(header.key) }}</v-icon>
          </template>
        </td>
      </tr>
      </thead>
    <tbody>
      <ReportItem
        class="report-item"
        :class="{
          'blue-grey lighten-5': report.Status === 'C'
        }"
        v-for="(report, reportKey) in orderedReports"
        :key="reportKey"
        :columns="columns"
        :checked="checked"
        v-model="orderedReports[reportKey]"
        @rowClick="onRowClick"
        @onContextMenu="showContext"
        @deleteReport="$emit('deleteReport', $event)"
        @addSelectedReport="addSelectedReport"
        @removeSelectedReport="removeSelectedReport"
      />
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'ReportItems',
  components: {
    ReportItem: () => import('@/components/manager_reports/ReportItem.vue')
  },
  props: {
    value: {
      required: false,
      type: Array
    },
    columns: {
      required: true
    },
    groupRef: {
      required: false
    },
    pagination: {
      required: false
    },
    group: {
      required: true,
      type: Object
    },
    isGroupedByEmployee: {
      required: true,
      type: [Boolean, Number]
    }
  },
  data () {
    return {
      checked: false,
      orderBy: {
        key: null,
        state: 0,
        groupIndex: null
      }
    }
  },
  computed: {
    topPositionForHeader () {
      return this.groupRef && this.groupRef[0] ? this.groupRef[0].offsetHeight + 'px' : 0
    },
    headers () {
      return this.columns.filter(c => !c.hide).map(col => {
        return {
          title: col.title,
          key: col.key,
          colWidth: col.colWidth
        }
      })
    },
    reports () {
      let res = [...this.value]
      if (this.pagination) {
        res = res.slice((this.pagination.currentPage - 1) * this.pagination.reportsPerPage, this.pagination.currentPage * this.pagination.reportsPerPage)
      }
      return res
    },
    widthStyle () {
      return width => {
        let widthStyle = ''
        if (width) {
          widthStyle = `
            width: ${width};
            max-width: ${width};
            min-width: ${width};
          `
        }
        return widthStyle
      }
    },
    colStyles () {
      return (col) => {
        return this.widthStyle(col.colWidth)
      }
    },
    orderWay () {
      return (key) => {
        if (key === this.orderBy.key) {
          if (this.orderBy.state === 1) {
            return 'mdi-arrow-down-thin'
          }
          if (this.orderBy.state === 2) {
            return 'mdi-arrow-up-thin'
          }
        }
        return null
      }
    },
    orderedReports () {
      if (this.orderBy.key) {
        const ordered = Object.assign([], this.reports).sort((a, b) => {
          if (a[this.orderBy.key] < b[this.orderBy.key]) return this.orderBy.state === 1 ? -1 : 1
          if (a[this.orderBy.key] > b[this.orderBy.key]) return this.orderBy.state === 1 ? 1 : -1
          return 0
        })
        return ordered
      }
      return this.reports
    }
  },
  methods: {
    toggleGroupReports (e) {
      if (e) {
        this.$emit('addSelectedReport', this.value.filter(r => r.Status === 'U' && !r.Locked).map(r => r.Reporting_ID))
      } else {
        this.$emit('removeSelectedReport', this.value.filter(r => r.Status === 'U' && !r.Locked).map(r => r.Reporting_ID))
      }
    },
    setAllInvoiceDurToZero () {
      const reportIdsToUpdate = this.group.reports
        .filter(r => r.Status === 'U' && !r.Locked)
        .map(r => r.Reporting_ID)

      if (!reportIdsToUpdate.length) return

      this.$emit('batchUpdateInvoiceDur', reportIdsToUpdate)
    },
    addSelectedReport (e) {
      this.$emit('addSelectedReport', e)
    },
    removeSelectedReport (e) {
      this.$emit('removeSelectedReport', e)
    },
    onRowClick (e) {
      this.$emit('rowClick', e)
    },
    showContext (e) {
      this.$emit('onContextMenu', e)
    },
    onOrderBy (key) {
      if (this.orderBy.key === key) {
        if (this.orderBy.state === 0) {
          this.orderBy.state = 1
          return
        }
        if (this.orderBy.state === 1) {
          this.orderBy.state = 2
          return
        }
        if (this.orderBy.state === 2) {
          this.orderBy.state = 0
          this.orderBy.key = null
        }
      } else {
        this.orderBy.key = key
        this.orderBy.state = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .report-item {
    border-top: 1px solid #d7d7d7;

    &:first-child {
      border-top: none;
    }

    .theme--dark & {
      border-top-color: #333;
    }
  }

  .header {
    white-space: nowrap;
    position: sticky;
    top: 25px;
    background-color: #ffffff;
    border-bottom: 1px solid #d7d7d7;
    z-index: 1;

    &__item {
      vertical-align: middle;
      padding: 0 17px 0 5px;
      font-size: 0.75rem;
      font-weight: 800;
      line-height: 1rem;
      border-right: 1px solid #d7d7d7;
      user-select: none;
      cursor: pointer;
      color: #000;

      &:last-child {
        border: none;
      }

      &.active {
        color: #1976d2;
        padding: 0 5px;
      }
    }

    .theme--dark & {
      background-color: #1e1e1e;
      border-bottom-color: #333;

      .header__item {
        color: #e0e0e0;
        border-right-color: #333;

        &.active {
          color: #64b5f6;
        }
      }
    }

    .theme--light & {
      background-color: #ffffff;
      border-bottom-color: #d7d7d7;

      .header__item {
        color: inherit;
        border-right-color: #d7d7d7;

        &.active {
          color: #1976d2;
        }
      }
    }
  }

  .blue-grey.lighten-5 {
    background-color: #ebeff2;

    .theme--dark & {
      background-color: #2c2c2c;
  }
}
</style>
